<div
  *ngIf="!params.node.rowPinned"
  class="m-1 d-flex align-items-center action-renderer-icons"
>
  <ng-container *ngFor="let action of actionsList">
    <span
      *ngIf="action.isShow(params, action)"
      nz-icon
      [nzType]="['design', 'media', 'leave', 'change'].includes(action.key) ? '' : action.key"
      nzTheme="outline"
      class="p-2 cursor-pointer"
      nz-tooltip
      [nzTooltipTitle]="getTooltipTitle(action)"
      (click)="onClick(action.code)"
    >
      <img
        *ngIf="action.key == 'design'"
        src="./assets/images/sidebar/media-apps.svg"
        alt="media icon"
        class="design-icon media-icon"
      />
        <img *ngIf="action.key == 'media'"
          src="./assets/images/view_design.svg"
          alt="media icon"
          class="design-icon media-icon"
        />
        <img *ngIf="action.key == 'leave'"
          src="./assets/images/leave-group.png"
          alt="media icon"
          class="design-icon media-icon"
        />
        <img *ngIf="action.key == 'change'"
          src="./assets/images/change-group.png"
          alt="media icon"
          class="design-icon media-icon"
        />
    </span>
  </ng-container>
</div>
